import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Copy, X } from "lucide-react";
import { api } from "../lib/api";

const DISMISS_KEY = "fl_promo_dismissed";

const countdown = (endsAt) => {
  if (!endsAt) return "";
  const ms = new Date(endsAt).getTime() - Date.now();
  if (ms <= 0) return "";
  const days = Math.floor(ms / 86400000);
  const hours = Math.floor((ms % 86400000) / 3600000);
  const mins = Math.floor((ms % 3600000) / 60000);
  if (days >= 1) return `${days}d ${hours}h left`;
  return hours >= 1 ? `${hours}h ${mins}m left` : `${mins}m left`;
};

// Live offers the admin chose to advertise (Admin → Discounts & coupons → "Advertise in the storefront banner").
export default function PromoBar() {
  const { locale = "en" } = useParams();
  const [offers, setOffers] = useState([]);
  const [index, setIndex] = useState(0);
  const [copied, setCopied] = useState(false);
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem(DISMISS_KEY) === "1"; } catch (_) { return false; }
  });
  const [tick, setTick] = useState(0);

  useEffect(() => {
    api.get(`/public/offers?locale=${locale}`).then((r) => setOffers(r.data.offers || [])).catch(() => {});
  }, [locale]);

  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 60000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    if (offers.length < 2) return undefined;
    const id = setInterval(() => setIndex((i) => (i + 1) % offers.length), 7000);
    return () => clearInterval(id);
  }, [offers.length]);

  if (dismissed || offers.length === 0) return null;
  const offer = offers[index % offers.length];
  if (!offer?.headline) return null;
  const left = countdown(offer.ends_at, tick);

  return (
    <div className="bg-ink text-plaster" data-testid="promo-bar">
      <div className="max-w-content mx-auto px-6 py-2.5 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm">
        <p className="font-medium" data-testid="promo-headline">{offer.headline}</p>
        {offer.code ? (
          <button className="inline-flex items-center gap-1.5 border border-brass/60 px-2.5 py-1 text-xs tracking-wide hover:bg-brass hover:text-ink transition-colors duration-200"
                  data-testid="promo-code"
                  onClick={() => { navigator.clipboard?.writeText(offer.code); setCopied(true); }}>
            <Copy size={11} /> {copied ? "Copied" : offer.code}
          </button>
        ) : null}
        {left ? <span className="text-xs text-brass tabular" data-testid="promo-countdown">{left}</span> : null}
        <button className="ms-auto text-plaster/60 hover:text-plaster" data-testid="promo-dismiss"
                onClick={() => { setDismissed(true); try { sessionStorage.setItem(DISMISS_KEY, "1"); } catch (_) {} }}>
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
